import React from 'react';
import { Select, Input, DatePicker, Button } from '@douyinfe/semi-ui';
import { IconSearch, IconFilter, IconRefresh } from '@douyinfe/semi-icons';

export const PRESETS = [
  { key: 'all', label: '全部' },
  { key: 'today', label: '今天' },
  { key: 'yesterday', label: '昨天' },
  { key: '7d', label: '近 7 天' },
  { key: '30d', label: '近 30 天' },
];

// 计算预设对应的时间范围（秒级时间戳，[start, end)），all 返回 null
export function getPresetRange(preset) {
  const now = new Date();
  const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (preset) {
    case 'today':
      return [dayStart.getTime() / 1000, dayStart.getTime() / 1000 + 86400];
    case 'yesterday':
      return [dayStart.getTime() / 1000 - 86400, dayStart.getTime() / 1000];
    case '7d':
      return [dayStart.getTime() / 1000 - 6 * 86400, dayStart.getTime() / 1000 + 86400];
    case '30d':
      return [dayStart.getTime() / 1000 - 29 * 86400, dayStart.getTime() / 1000 + 86400];
    default:
      return null;
  }
}

const DEFAULT_FILTERS = {
  preset: 'all',
  customRange: null, // [Date, Date]
  models: [],
  keyword: '',
};

export { DEFAULT_FILTERS };

// 筛选行：时间范围预设 / 自定义区间 / 模型多选 / 关键词。作用于下方所有统计与表格
const FilterBar = ({ filters, onChange, modelOptions }) => {
  const set = (patch) => onChange({ ...filters, ...patch });

  const isDefault =
    filters.preset === 'all' &&
    !filters.customRange &&
    filters.models.length === 0 &&
    filters.keyword === '';

  return (
    <div className="filter-row fade-up fade-up-1">
      <IconFilter style={{ color: 'var(--text-3)' }} aria-label="筛选" />
      <div className="preset-group" role="group" aria-label="时间范围">
        {PRESETS.map((p) => (
          <button
            key={p.key}
            className={`preset-btn${filters.preset === p.key && !filters.customRange ? ' active' : ''}`}
            onClick={() => set({ preset: p.key, customRange: null })}
          >
            {p.label}
          </button>
        ))}
      </div>
      <DatePicker
        type="dateRange"
        density="compact"
        placeholder={['开始日期', '结束日期']}
        className="filter-date"
        value={filters.customRange || undefined}
        onChange={(dates) => {
          if (Array.isArray(dates) && dates.length === 2 && dates[0] && dates[1]) {
            set({ customRange: dates, preset: 'custom' });
          } else {
            set({ customRange: null, preset: 'all' });
          }
        }}
        showClear
      />
      <Select
        multiple
        filter
        showClear
        maxTagCount={2}
        placeholder="全部模型"
        className="filter-models"
        optionList={modelOptions}
        value={filters.models}
        onChange={(models) => set({ models: models || [] })}
      />
      <Input
        showClear
        placeholder="搜索模型或详情关键词"
        prefix={<IconSearch />}
        className="filter-search"
        value={filters.keyword}
        onChange={(keyword) => set({ keyword })}
      />
      {!isDefault && (
        <Button
          icon={<IconRefresh />}
          theme="borderless"
          type="tertiary"
          size="small"
          onClick={() => onChange({ ...DEFAULT_FILTERS })}
        >
          重置
        </Button>
      )}
    </div>
  );
};

export default FilterBar;
